import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';

export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tienda, setTienda] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const items = [producto?.item1, producto?.item2, producto?.item3, producto?.item4, producto?.item5, producto?.item6, producto?.item7, producto?.item8, producto?.item9, producto?.item10];
    const [selectedItems, setSelectedItems] = useState([]);
    const [categorias, setCategorias] = useState([]);
    // const [selectedItem, setSelectedItem] = useState(items[0] || "");
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const location = useLocation();
    const categoriasInputRef = useRef(null);
    const [fixedCategories, setFixedCategories] = useState(false);
    const [subcategorias, setSubCategorias] = useState([]);
    useEffect(() => {
        cargarProductos();
        cargarTienda();
        cargarFavoritos();
        cargarCategoria()
        cargarSubCategoria()
        if (items.length > 0) {
            setSelectedItemIndex(0);
        }

    }, []);
    useEffect(() => {

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarSubCategoria = () => {
        fetch(`${baseURL}/subCategoriaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setSubCategorias(data.subcategorias || []);
                console.log(data.subcategorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };
    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse() || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };
    const cargarProductos = () => {
        // Carga solo el producto que se necesita por ID
        // Evita traer todos los productos con imágenes Base64 (error de memoria)
        fetch(`${baseURL}/productoGet.php?idProducto=${idProducto}`)
            .then(response => response.json())
            .then(data => {
                if (data.producto) {
                    setProducto(data.producto);
                    setProductos([data.producto]);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar producto:', error);
                setLoading(true);
            });
    };


    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(localStorage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleCheckboxChange = (item) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter(i => i !== item));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };




    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            })
                .then(() => console.log('Contenido compartido correctamente'))
                .catch((error) => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    }

    const handleWhatsappMessage = () => {
        const phoneNumber = tienda[0]?.telefono;
        const removeAccents = (str) => {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza y elimina acentos
        };

        const title = encodeURIComponent(removeAccents(producto?.titulo)?.replace(/\s+/g, '-'));

        const formattedPrice = Number(producto?.precio).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        // Verifica si hay items seleccionados
        const selectedItemsText = selectedItems.length > 0
            ? selectedItems.join(', ')
            : "";

        const message = `Hola 🌟, quisiera más información sobre\n\n✅ *${title}*\n     ${selectedItemsText}\n     ${moneda} ${formattedPrice}`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        //const whatsappUrl = `https://api.whatsapp.com/send?phone=${+573004085041}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
    };


    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate('/');
        }
    };




    const addToCart = () => {
        if (producto) {
            const stockNum = Number(producto.stock);
            const stockTexto = String(producto.stock).toLowerCase();

            // Si el stock es "agotado" o 0 → no se puede agregar
            if (stockTexto === 'agotado' || stockNum <= 0) {
                toast.error('Este producto está agotado', { autoClose: 1500 });
                return;
            }

            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const existingItemIndex = cart.findIndex(item =>
                item.idProducto === producto.idProducto
            );
            const itemsToAdd = producto.verItems === "Si" ? selectedItems : [];

            // Si el stock es numérico, validar que no supere las piezas disponibles
            if (!isNaN(stockNum) && stockTexto !== 'disponible') {
                const cantidadEnCarrito = existingItemIndex !== -1 ? cart[existingItemIndex].cantidad : 0;
                const totalConNuevo = cantidadEnCarrito + cantidad;

                if (totalConNuevo > stockNum) {
                    const disponibles = stockNum - cantidadEnCarrito;
                    if (disponibles <= 0) {
                        toast.error(
                            `Ya agregaste todas las piezas disponibles (${stockNum}) al carrito.`,
                            { autoClose: 2500 }
                        );
                    } else {
                        toast.error(
                            `Solo quedan ${stockNum} piezas. Ya tenés ${cantidadEnCarrito} en el carrito, podés agregar ${disponibles} más.`,
                            { autoClose: 2500 }
                        );
                    }
                    return;
                }
            }

            if (existingItemIndex !== -1) {
                const existingItem = cart[existingItemIndex];
                const updatedItems = [...existingItem.items, ...itemsToAdd];
                const updatedCantidad = existingItem.cantidad + cantidad;
                cart[existingItemIndex] = { ...existingItem, items: updatedItems, cantidad: updatedCantidad };
            } else {
                cart.push({ idProducto: producto.idProducto, items: itemsToAdd, cantidad });
            }

            localStorage.setItem('cart', JSON.stringify(cart));
            toast.success('Producto agregado', { autoClose: 400 });
            setTimeout(() => window.location.reload(), 600);
        }
    };


    const incrementCantidad = useCallback(() => {
        setCantidad(prev => prev + 1);
    }, []);

    const decrementCantidad = useCallback(() => {
        setCantidad(prev => (prev > 1 ? prev - 1 : 1));
    }, []);


    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            // Si el producto no está en favoritos, lo agregamos
            favList.push(idProducto);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto agregado a favoritos');

        } else {
            // Si el producto está en favoritos, lo eliminamos
            favList.splice(index, 1);
            setFavoritos(favList);
            localStorage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto eliminado de favoritos');
        }
    };



    if (!producto) {
        return <DetailLoading />;
    }


    return (


        <div className="detail">

            <ToastContainer />
            <div className={`deFlexDetail ${fixedCategories ? 'fixedHeader' : ''}`} ref={categoriasInputRef}>
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>

                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>


            </div>
            <div className="detail-contain">
                <SwiperSlide id={"swiperDetail"} >
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        loop={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        autoplay={{ delay: 3000 }} // Cambia el valor de 'delay' según tus preferencias
                        pagination={{ clickable: true, }}
                        onSwiper={(swiper) => {
                            console.log(swiper);
                            swiperRef.current = swiper;
                        }}

                    >

                        {
                            producto.imagen1 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen1}
                                            alt={producto.titulo}
                                            className="imagen1"
                                            onClick={() => {
                                                setModalImage(producto.imagen1);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }

                        {
                            producto.imagen2 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen2}
                                            alt={producto.titulo}
                                            className="imagen2"
                                            onClick={() => {
                                                setModalImage(producto.imagen2);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                        {
                            producto.imagen3 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen3}
                                            alt={producto.titulo}
                                            className="img"
                                            onClick={() => {
                                                setModalImage(producto.imagen3);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                        {
                            producto.imagen4 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen4}
                                            alt={producto.titulo}
                                            className="imagen4"
                                            onClick={() => {
                                                setModalImage(producto.imagen4);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                    </Swiper>
                </SwiperSlide>
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {
                            categorias
                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                .map(categoriaFiltrada => (
                                    <h4>  <FontAwesomeIcon icon={faStar} />{categoriaFiltrada.categoria}
                                        {subcategorias
                                            ?.filter(subcategoriaFiltrada => subcategoriaFiltrada.idSubCategoria === producto.idSubCategoria)
                                            ?.map(subcategoriaFiltrada => (
                                                <>
                                                    {` >`}  {subcategoriaFiltrada?.subcategoria}
                                                </>
                                            ))
                                        }
                                    </h4>

                                ))
                        }
                        {/* Muestra el stock disponible de forma clara para el cliente */}
                        {producto.stock === 'agotado' || producto.stock === 'Agotado' || Number(producto.stock) <= 0 ? (
                            // Sin stock → etiqueta roja
                            <h4 style={{ color: 'red', backgroundColor: '#ffc1c1', padding: '4px 10px', borderRadius: '6px' }}>
                                Agotado
                            </h4>
                        ) : producto.stock === 'disponible' || producto.stock === 'Disponible' ? (
                            // Stock manual "disponible" → sin cantidad exacta
                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '4px 10px', borderRadius: '6px' }}>
                                Disponible
                            </h4>
                        ) : Number(producto.stock) === 1 ? (
                            // Última pieza → aviso especial en naranja
                            <h4 style={{ color: '#cc6600', backgroundColor: '#fff3cc', padding: '4px 10px', borderRadius: '6px' }}>
                                ¡Última pieza!
                            </h4>
                        ) : (
                            // Cantidad exacta → muestra cuántas quedan
                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '4px 10px', borderRadius: '6px' }}>
                                {Number(producto.stock)} piezas disponibles
                            </h4>
                        )}
                    </div>

                    <PrecioDetail producto={producto} moneda={moneda} />
                    <div className="descripcionHtml" dangerouslySetInnerHTML={{ __html: producto.descripcion }} />
                    {
                        producto?.verItems === 'Si' && (
                            <div className="itemsDetail">
                                {items.map((item, index) => (
                                    item && (
                                        <label key={index}>
                                            <input
                                                type="checkbox"
                                                checked={selectedItems.includes(item)}
                                                onChange={() => handleCheckboxChange(item)}
                                            />
                                            <span>  {item}</span>
                                        </label>
                                    )
                                ))}
                            </div>
                        )
                    }


                    <div className='deFlexCart'>
                        <button type="button" onClick={decrementCantidad}>-</button>
                        <span>{cantidad}</span>
                        <button type="button" onClick={incrementCantidad}>+</button>
                    </div>
                    <div className='deFlexGoTocart'>
                        <button onClick={() => addToCart(items[selectedItemIndex])} className='btnAdd'>Agregar  <FontAwesomeIcon icon={faShoppingCart} />  </button>
                        <button className="wpp" onClick={handleWhatsappMessage}>
                            WhatsApp
                            <img src={whatsappIcon} alt="whatsappIcon" />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{
                    modal: 'custom-modal',
                }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
        </div>

    )
}






// ════════════════════════════════════════════════════════════
// SUBCOMPONENTE: PrecioDetail
// Muestra el precio correcto al cliente:
//  - Si hay precio especial activo dentro del período → muestra
//    el precio con descuento (rojo) y el original tachado
//  - Si no → muestra el precio normal con precioAnterior tachado
// ════════════════════════════════════════════════════════════
function PrecioDetail({ producto, moneda }) {
    const hoy = new Date();

    // Verifica si hoy está dentro del período configurado
    const dentroDelPeriodo =
        (!producto.precioEspecialInicio || hoy >= new Date(producto.precioEspecialInicio)) &&
        (!producto.precioEspecialFin    || hoy <= new Date(producto.precioEspecialFin));

    const tienePrecioEspecial = producto.precioEspecial && dentroDelPeriodo;

    // Calcula el precio final visible
    let precioFinal = Number(producto.precio);
    if (tienePrecioEspecial) {
        if (producto.tipoPrecioEspecial === 'porcentaje') {
            // Ej: precio 100 con 15% → muestra 85
            precioFinal = precioFinal - (precioFinal * Number(producto.precioEspecial) / 100);
        } else {
            // Precio fijado directamente
            precioFinal = Number(producto.precioEspecial);
        }
    }

    const fmt = (n) => `${moneda} ${String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;

    return (
        <div className='deFLexPrice'>

            {/* Precio final que ve el cliente */}
            <h5 className={tienePrecioEspecial ? 'price precioOferta' : 'price'}>
                {fmt(precioFinal)}
                {tienePrecioEspecial && (
                    <span className='badgeOfertaDetail'>
                        {producto.tipoPrecioEspecial === 'porcentaje'
                            ? `-${producto.precioEspecial}%`
                            : 'Oferta'}
                    </span>
                )}
            </h5>

            {/* Si hay precio especial activo: muestra el precio original tachado */}
            {tienePrecioEspecial && (
                <h5 className='precioTachadoDetail'>
                    {fmt(Number(producto.precio))}
                </h5>
            )}

            {/* Si NO hay precio especial: muestra precioAnterior tachado (si existe) */}
            {!tienePrecioEspecial &&
                producto.precioAnterior !== 0 &&
                producto.precioAnterior !== undefined &&
                producto.precioAnterior !== null && (
                <h5 className='precioTachadoDetail'>
                    {fmt(Number(producto.precioAnterior))}
                </h5>
            )}
        </div>
    );
}
